const { Deserializer } = require('jsonapi-serializer');

const deserializeClusterExtensionLogs = async (payload) => {
  return await new Deserializer({
    keyForAttribute: 'camelCase'
  }).deserialize(payload);
};

module.exports = {
  deserializeClusterExtensionLogs
};